import { JournalFileType } from 'app/shared/enums/journal-file-type.enum';
import { JobNotificationCardModel } from '../job-notification-card.model';

export class JournalNotificationCardModel extends JobNotificationCardModel {
  public journalFileType: JournalFileType;
}
